// Overlay de "primera selección": se muestra cuando el usuario autenticado
// todavía no tiene una sucursal operativa elegida en este navegador (o la
// que tenía guardada dejó de estar activa). No bloquea el login: sólo
// aparece una vez que ya hay usuario autenticado.
import { Dialog, DialogTitle, DialogContent, Button, Stack, Typography } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { useSucursalOperativa } from "../context/SucursalOperativaContext";

export default function SeleccionarSucursalGate() {
  const { loading, necesitaSeleccion, sucursales, seleccionar } = useSucursalOperativa();

  if (loading || !necesitaSeleccion) return null;

  return (
    <Dialog open disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle>¿Dónde estás trabajando?</DialogTitle>
      <DialogContent>
        {sucursales.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
            No hay sucursales activas configuradas. Contactá a un administrador.
          </Typography>
        ) : (
          <Stack spacing={1.5} sx={{ mt: 1, mb: 2 }}>
            {sucursales.map((s) => (
              <Button
                key={s.id}
                variant="outlined"
                size="large"
                startIcon={<StorefrontIcon />}
                onClick={() => seleccionar(s.id)}
              >
                {s.nombre}
              </Button>
            ))}
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}
